import _ from 'underscore'

export const sortUsers = (users) => 
  _.sortBy(users, function (i) { return i.firstName.toLowerCase() })


// WEBPACK FOOTER //
// ./src/client/features/users/lib.js